import React from 'react';

import { Link } from '@klp/design/Link';
import { UserRoutes } from '@klp/user/config';
import type { Theme } from '@material-ui/core';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { PeopleOutline } from '@material-ui/icons';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

const styles = (theme: Theme) => ({
    link: {
        transition: 'color 0.3s',
        color: theme.palette.primary.mediumLight,
        '&:hover': {
            color: theme.palette.background.paper,
            '&:before': {
                backgroundColor: theme.palette.tertiary?.medium,
            },
        },
    },
    icon: {
        color: theme.palette.primary.mediumLight,
    },
});

export const SidebarUserAdministration = () => {
    const classes = useKlpStyles({}, styles);
    return (
        <ListItem>
            <ListItemIcon className={classes.icon}>
                <PeopleOutline />
            </ListItemIcon>
            <ListItemText>
                <Link
                    className={classes.link}
                    href={UserRoutes.moduleRoute()}
                    translation="users.title"
                />
            </ListItemText>
        </ListItem>
    );
};
